import { useQuery } from "@tanstack/react-query";
import { isUiMockMode } from "@/config/features";
import { buildExportListApiParams } from "@/domain/export/buildExportListApiParams";
import type { ExportListFilters } from "@/domain/export/filterExportJobs";
import { filterExportJobs } from "@/domain/export/filterExportJobs";
import { isExportActive } from "@/domain/export/exportStatusUi";
import { mockExportJobsList } from "@/fixtures/exportJobs";
import { fetchExportJobs } from "@/features/exports/api/list";
import { exportKeys } from "@/lib/query/keys";

export function useExportJobs(
  page: number,
  pageSize: number,
  filters: ExportListFilters,
) {
  const mock = isUiMockMode();
  const apiParams = buildExportListApiParams(page, pageSize, filters);

  return useQuery({
    queryKey: [...exportKeys.all, "list", apiParams],
    queryFn: async () => {
      if (mock) {
        const all = mockExportJobsList(0, 500);
        const filtered = filterExportJobs(all.items, filters);
        const start = page * pageSize;
        const slice = filtered.slice(start, start + pageSize);
        return {
          items: slice,
          page,
          page_size: pageSize,
          has_more: start + pageSize < filtered.length,
        };
      }
      return fetchExportJobs(apiParams);
    },
    refetchInterval: mock
      ? false
      : (query) => {
          const items = query.state.data?.items ?? [];
          return items.some((j) => isExportActive(j.status)) ? 3000 : false;
        },
  });
}
